import { initReactI18next } from "react-i18next";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-xhr-backend";

import { getItem } from "helpers/localStorage";

import { LOCALSTORAGE_KEY } from "constants/index";

const options = {
  order: ["querystring", "navigator"],
  lookupQuerystring: "lng",
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: options,
    fallbackLng: "ja",
    lng: "ja",
    debug: false,
    backend: {
      loadPath: "/locales/{{lng}}.json",
      queryStringParams: {
        v: getItem(LOCALSTORAGE_KEY.BUILD_VERSION) || new Date().getTime(),
      },
    },
  });

export default i18n;
